/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConfigurePriceQuote = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h11.414l9 9-2.207 2.207-1.414-1.414.793-.793-7-7H4v8.55l8.664 7.703-1.328 1.494L2 13.45zm6 6H6V6h2z" />
        <path d="M17.5 15.145V14h2v1.145c.233.07.455.162.665.276l.81-.81 1.414 1.414-.81.81c.114.21.207.432.276.665H23v2h-1.145c-.07.233-.162.455-.276.665l.81.81-1.414 1.414-.81-.81a3.44 3.44 0 0 1-.665.276V23h-2v-1.145a3.481 3.481 0 0 1-.665-.276l-.81.81-1.414-1.414.81-.81a3.481 3.481 0 0 1-.276-.665H14v-2h1.145c.07-.233.162-.455.276-.665l-.81-.81 1.414-1.414.81.81a3.44 3.44 0 0 1 .665-.276zM20 18.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgConfigurePriceQuote as ConfigurePriceQuote };
